import * as App from '@services/store/actions/app'

import * as LandingZonesAction from './landingZones/action'
import * as LandingZonesTypes from './landingZones/types'

import * as LandingZonesGroupsAction from './landingZones/Groups/action'
import * as LandingZonesGroupsTypes from './landingZones/Groups/types'

import * as LandingZonesMigrationAction from './landingZones/Migration/action'
import * as LandingZonesMigrationTypes from './landingZones/Migration/types'

import * as LandingZonesServicesAction from './landingZones/Services/action'
import * as LandingZonesServicesTypes from './landingZones/Services/types'

import * as LandingZonesTagsAction from './landingZones/Tags/action'
import * as LandingZonesTagsTypes from './landingZones/Tags/types'

import * as LandingZonesTeamsAction from './landingZones/Teams/action'
import * as LandingZonesTeamsTypes from './landingZones/Teams/types'

import * as ServiceHealthAction from './serviceHealth/action'
import * as ServiceHealthTypes from './serviceHealth/types'

import * as FirewallLogsAction from './firewallLogs/action'
import * as FirewallLogsTypes from './firewallLogs/types'

const FeaturesStore = {
    LandingZones: {
        action: LandingZonesAction,
        types: LandingZonesTypes
    },
    LandingZoneGroups: {
        action: LandingZonesGroupsAction,
        types: LandingZonesGroupsTypes
    },
    LandingZoneMigration: {
        action: LandingZonesMigrationAction,
        types: LandingZonesMigrationTypes
    },
    LandingZoneServices: {
        action: LandingZonesServicesAction,
        types: LandingZonesServicesTypes
    },
    LandingZoneTags: {
        action: LandingZonesTagsAction,
        types: LandingZonesTagsTypes
    },
    LandingZoneTeams: {
        action: LandingZonesTeamsAction,
        types: LandingZonesTeamsTypes
    },
    ServiceHealth: {
        action: ServiceHealthAction,
        types: ServiceHealthTypes
    },
    FirewallLogs: {
        action: FirewallLogsAction,
        types: FirewallLogsTypes
    }
}

export {
    App,
    FeaturesStore
}